import React, { useState } from 'react';
import ModalPortal from '../../../components/ModalPortal';
import { getDemoSandboxUrl } from '../../../utils/config';

const CopyableRow = ({ label, value, copyLabel = 'Copy' }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        if (!value) return;
        await navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.25rem' }}>
                {label}
            </label>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
                <input
                    type="text"
                    className="input-field"
                    value={value || ''}
                    readOnly
                    style={{ fontFamily: 'monospace', fontSize: '0.85rem', padding: '0.5rem 0.75rem' }}
                />
                <button
                    type="button"
                    className="btn-secondary"
                    onClick={handleCopy}
                    disabled={!value}
                    style={{
                        padding: '0.5rem 1rem',
                        whiteSpace: 'nowrap',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.25rem',
                        background: copied ? 'var(--success)' : 'transparent',
                        color: copied ? 'white' : 'var(--text-secondary)'
                    }}
                >
                    {copied
                        ? <><i className="fa-solid fa-check"></i> Copied</>
                        : <><i className="fa-regular fa-copy"></i> {copyLabel}</>}
                </button>
            </div>
        </div>
    );
};

const ShareDeploymentModal = ({
    isOpen,
    onClose,
    deployment,
    overlayMouseDown
}) => {
    if (!isOpen || !deployment) return null;

    const demoUrl = getDemoSandboxUrl(deployment.embedToken);
    const password = deployment.demoPassword || '';

    return (
        <ModalPortal>
            <div
                className="modal-overlay"
                onMouseDown={(e) => {
                    if (e.target === e.currentTarget) overlayMouseDown.current = true;
                }}
                onMouseUp={(e) => {
                    if (e.target === e.currentTarget && overlayMouseDown.current) {
                        onClose();
                    }
                    overlayMouseDown.current = false;
                }}
            >
                <div className="modal-content" onClick={e => e.stopPropagation()} style={{ minWidth: '480px', padding: '1.25rem' }}>
                    <h2 style={{ color: 'var(--text-primary)', margin: '0 0 0.5rem 0', fontSize: '1.25rem' }}>Share demo sandbox</h2>
                    <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem', fontSize: '0.85rem' }}>
                        Send this link to a guest. {password ? 'They will need the password to open the configurator.' : 'Anyone with the link can open it until you set a password.'}
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                        <CopyableRow label="Demo link" value={demoUrl} copyLabel="Copy link" />
                        {password ? (
                            <CopyableRow label="Password" value={password} copyLabel="Copy password" />
                        ) : null}

                        <div className="modal-actions" style={{ marginTop: '0.5rem', display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
                            <button
                                type="button"
                                className="btn-secondary"
                                onClick={() => window.open(demoUrl, '_blank', 'noopener,noreferrer')}
                                disabled={!demoUrl}
                            >
                                <i className="fa-solid fa-arrow-up-right-from-square" style={{ marginRight: '0.35rem' }}></i>
                                Open
                            </button>
                            <button type="button" className="btn-primary" onClick={onClose} style={{ background: 'var(--text-primary)', color: 'var(--bg-primary)' }}>
                                Done
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ModalPortal>
    );
};

export default ShareDeploymentModal;
export { CopyableRow };
